import axios from "axios";
import authHeader from "@/services/auth-header";

class CustomFieldService {
  get(fileDataId) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/CustomFields/${fileDataId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  update(customFields, fileDataId) {
    return axios
      .put(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/CustomFields/${fileDataId}`,
        customFields,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  checkConcurrentWork(fileDataId) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/BytePro/CustomFields/CheckConcurrentWork/${fileDataId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new CustomFieldService();
